// Define meeting constants

module.exports = {
  MEETING_ADD_TOPIC_NEW: "meeting_add_topic_new",
  MEETING_ADD_TOPIC_ITEMS: "MEETING_ADD_TOPIC_ITEMS",
  MEETING_TOPIC_TAKE_UPDATE: "MEETING_TOPIC_TAKE_UPDATE",
  MEETING_ADD_TOPIC_TAG: "MEETING_ADD_TOPIC_TAG",
  MEETING_ADD_NON_TOPIC_TAG: "MEETING_ADD_NON_TOPIC_TAG",
  MEETING_ADD_TAKE_TAG: "MEETING_ADD_TAKE_TAG",
  MEETING_TOPIC_UPDATE: "MEETING_TOPIC_UPDATE",
  MEETING_NON_TAKE_UPDATE: "MEETING_NON_TAKE_UPDATE",
  MEETING_ADD_TAKEAWAY_ITEM: "MEETING_ADD_TAKEAWAY_ITEM",
  MEETING_ADD_TOPIC_TAKEAWAY_ITEM: "MEETING_ADD_TOPIC_TAKEAWAY_ITEM",
  MEETING_DELETE_TOPIC: "MEETING_DELETE_TOPIC",
  MEETING_DELETE_TOPIC_TAKEAWAY: "MEETING_DELETE_TOPIC_TAKEAWAY",
  MEETING_DELETE_NON_TOPIC_TAKEAWAY: "MEETING_DELETE_NON_TOPIC_TAKEAWAY",
  MEETING_UPDATE_PACE_VALUES: "MEETING_UPDATE_PACE_VALUES",
  MEETING_UPDATE_TRENDS: "MEETING_UPDATE_TRENDS",
  MEETING_UPDATE_TOPIC_ID: "MEETING_UPDATE_TOPIC_ID",
  MEETING_UPDATE_TOPIC_TAKE_ID: "MEETING_UPDATE_TOPIC_TAKE_ID",
  MEETING_UPDATE_NON_TAKEAWAY_ID: "MEETING_UPDATE_NON_TAKEAWAY_ID",
  MEETING_SHARE_TOPIC: "MEETING_SHARE_TOPIC",
  MEETING_UPDATE_OBJECT: "MEETING_UPDATE_OBJECT",
  MEETING_CHANGE_PAGE: "MEETING_CHANGE_PAGE",
  MEETING_UPDATE_TIMER_COUNTER: "MEETING_UPDATE_TIMER_COUNTER",
  MEETING_UPDATE_INVITEES: "MEETING_UPDATE_INVITEES",
  MEETING_REMOVE_INVITEE: "MEETING_REMOVE_INVITEE",
  MEETING_NAME_UPDATE: "MEETING_NAME_UPDATE",
  MEETING_UPDATE_INVITEE_ACCESS: "MEETING_UPDATE_INVITEE_ACCESS",
  MEETING_SYNC_DATA: "MEETING_SYNC_DATA",
  MEETING_UPDATE_TIMER_STATUS: "MEETING_UPDATE_TIMER_STATUS",
  MEETING_UPDATE_POPUP_DATA: "MEETING_UPDATE_POPUP_DATA",
  MEETING_SORT_ITEM: "MEETING_SORT_ITEM",
  MEETING_UPDATE_USER_TEAM: "MEETING_UPDATE_USER_TEAM",
  MEETING_SORT_TAKE_ITEM: "MEETING_SORT_TAKE_ITEM",
  MEETING_ADD_TOPIC_ATTACHMENT: "MEETING_ADD_TOPIC_ATTACHMENT",
  MEETING_ADD_NOTE_ATTACHMENT: "MEETING_ADD_NOTE_ATTACHMENT",
  MEETING_DELETE_TOPIC_ATTACHMENT: "MEETING_DELETE_TOPIC_ATTACHMENT",
  MEETING_DELETE_NOTE_ATTACHMENT: "MEETING_DELETE_NOTE_ATTACHMENT",
  OBJECT_TYPE_MEETING: "meeting",
  UPDATE_MEETING_S3DATA: "UPDATE_MEETING_S3DATA",
  ADD_REMOVE_ITEM_RECURRING: "ADD_REMOVE_ITEM_RECURRING",
  ADD_REMOVE_ALL_ITEM_RECURRING: "ADD_REMOVE_ALL_ITEM_RECURRING",
  MEETING_TOPIC_DISCUSS: "MEETING_TOPIC_DISCUSS",
  MEETING_TAKE_DISCUSS: "MEETING_TAKE_DISCUSS",
  MEETING_SEND_MINUTES_UPDATE: "MEETING_SEND_MINUTES_UPDATE",
  MEETING_WS_UPDATE: "MEETING_WS_UPDATE",
  MEETING_NEW_TOPIC: "MEETING_NEW_TOPIC",
  MEETING_UPDATE_TAKEAWAY_SMARTWOBO_SCORE:
    "MEETING_UPDATE_TAKEAWAY_SMARTWOBO_SCORE",
  MEETING_UPDATE_TAKEAWAY_SHOW_SMARTWOBO:
    "MEETING_UPDATE_TAKEAWAY_SHOW_SMARTWOBO",
  MEETING_UPDATE_TAKEAWAY_IGNORE_SMARTWOBO:
    "MEETING_UPDATE_TAKEAWAY_IGNORE_SMARTWOBO",
  MEETING_UPDATE_TAKEAWAYS_RESET_SMARTWOBO:
    "MEETING_UPDATE_TAKEAWAYS_RESET_SMARTWOBO",
  MEETING_UPDATE_TOPICS: "MEETING_UPDATE_TOPICS",
  MEETING_SET_TAKE_SMART_WOBO_ID: "MEETING_SET_TAKE_SMART_WOBO_ID",
  MEETING_UPDATE_TOPIC_ATTACHMENT:"MEETING_UPDATE_TOPIC_ATTACHMENT",
  MEETING_UPDATE_NOTE_ATTACHMENT:"MEETING_UPDATE_NOTE_ATTACHMENT",
};
